import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dx-viewport" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxToolbarItem = _resolveComponent("DxToolbarItem")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxValidationRule = _resolveComponent("DxValidationRule")!
  const _component_DxFormGrid = _resolveComponent("DxFormGrid")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopupAdd = _resolveComponent("DxPopupAdd")!

  return (_openBlock(), _createElementBlock("body", _hoisted_1, [
    _createVNode(_component_DxDataGrid, {
      ref: "dataGrid",
      allowColumnReordering: true,
      "data-source": _ctx.dsTipuriActivitati,
      allowColumnResizing: true,
      columnAutoWidth: false,
      columnMinWidth: 50,
      columnResizingMode: 'nextColumn',
      "show-borders": true,
      syncLookupFilterValues: false,
      "filter-sync-enabled": true,
      "show-row-lines": true,
      "show-column-lines": false,
      onSelectionChanged: _ctx.onSelectionChanged,
      onRowInserting: _ctx.onRowInserting,
      onRowUpdating: _ctx.onRowUpdating,
      onRowRemoving: _ctx.onRowRemoving,
      class: "border"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxFilterRow, { visible: true }),
        _createVNode(_component_DxPaging, {
          "page-size": 10,
          "page-index": 0
        }),
        _createVNode(_component_DxLoadPanel, {
          enabled: true,
          "indicator-src": 'reload6.gif'
        }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxStateStoring, {
          enabled: true,
          filterValue: false,
          "storage-key": "TipuriActivitati"
        }),
        _createVNode(_component_DxToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "add",
                  type: "success",
                  onClick: _ctx.onAddClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxItem, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "refresh",
                  onClick: _ctx.onRefreshClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxEditing, {
          allowUpdating: true,
          allowDeleting: true,
          mode: "popup"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxPopup, {
              showCloseButton: false,
              width: 600,
              height: 450
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxToolbarItem, { template: _ctx.customTitle }, null, 8, ["template"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "after",
                  options: _ctx.successButtonOptions
                }, null, 8, ["options"]),
                _createVNode(_component_DxToolbarItem, {
                  toolbar: "bottom",
                  widget: "dxButton",
                  location: "after",
                  options: _ctx.dangerButtonOptions
                }, null, 8, ["options"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxFormGrid, {
              colCount: 2,
              columnWidth: "300"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_DxItem, {
                  dataField: "Nume",
                  colSpan: 1,
                  cssClass: "form-item"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxValidationRule, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxRequiredRule)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxItem, {
                  dataField: "ValutaId",
                  editorType: 'dxSelectBox',
                  editorOptions: { dataSource: _ctx.valute, displayExpr: 'Simbol', valueExpr: 'Id', width: 260 },
                  cssClass: "form-item",
                  label: { text: 'Valută' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxValidationRule, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxRequiredRule)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["editorOptions"]),
                _createVNode(_component_DxItem, {
                  dataField: "DurataEstimata",
                  colSpan: 1,
                  cssClass: "form-item",
                  label: { text: 'Durată estimativă în zile' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxValidationRule, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxRequiredRule)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxItem, {
                  dataField: "CostImplicit",
                  colSpan: 1,
                  cssClass: "form-item",
                  "width:": "",
                  "250": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DxValidationRule, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxRequiredRule)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_DxItem, {
                  dataField: "Explicatie",
                  caption: "Explicație",
                  colSpan: 2,
                  "editor-options": { width: 560, height: 100 },
                  cssClass: "form-item-full"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, { "data-field": "Nume" }),
        _createVNode(_component_DxColumn, {
          "data-field": "Explicatie",
          caption: "Explicație"
        }),
        _createVNode(_component_DxColumn, { "data-field": "CostImplicit" }),
        _createVNode(_component_DxColumn, {
          "data-field": "DurataEstimata",
          caption: "Durată Estimată"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ValutaNume",
          caption: "Nume Valută"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ValutaId",
          caption: "Valuta",
          visible: false
        })
      ]),
      _: 1
    }, 8, ["data-source", "onSelectionChanged", "onRowInserting", "onRowUpdating", "onRowRemoving"]),
    _createVNode(_component_DxPopupAdd, {
      visible: _ctx.isModalVisible,
      showCloseButton: false,
      showTitle: true,
      width: 600,
      height: 430
    }, {
      title: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createElementVNode("div", { style: {"background-color":"#ff2c21","font-size":"15px","color":"white","font-weight":"bold","padding":"10px","padding-left":"20px"} }, " Adăugare ", -1)
      ]))]),
      default: _withCtx(() => [
        _createVNode(_component_DxToolbarItem, {
          toolbar: "bottom",
          widget: "dxButton",
          location: "after",
          options: _ctx.addSaveButtonOptions
        }, null, 8, ["options"]),
        _createVNode(_component_DxToolbarItem, {
          toolbar: "bottom",
          widget: "dxButton",
          location: "after",
          options: _ctx.addCancelButtonOptions
        }, null, 8, ["options"]),
        _createElementVNode("div", null, [
          _createVNode(_component_DxForm, { formData: _ctx.formData }, {
            default: _withCtx(() => [
              _createVNode(_component_DxItem, {
                "col-span": 2,
                "col-count": 2,
                "item-type": "group"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxItem, {
                    dataField: "Nume",
                    isRequired: true,
                    "editor-options": { width: 260 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxValidationRule, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxRequiredRule)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxItem, {
                    dataField: "ValutaId",
                    caption: "Valuta",
                    isRequired: true,
                    editorType: 'dxSelectBox',
                    editorOptions: { dataSource: _ctx.valute, displayExpr: 'Simbol', valueExpr: 'Id', width: 260 },
                    label: { text: 'Valută' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxValidationRule, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxRequiredRule)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["editorOptions"]),
                  _createVNode(_component_DxItem, {
                    dataField: "DurataEstimata",
                    isRequired: true,
                    "editor-options": { width: 260 },
                    label: { text: 'Durată estimativă în zile' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxValidationRule, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxRequiredRule)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_DxItem, {
                    dataField: "CostImplicit",
                    isRequired: true,
                    "editor-options": { width: 260 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxValidationRule, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_DxRequiredRule)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_DxItem, {
                dataField: "Explicatie",
                caption: "Explicație",
                "editor-options": { width: 560, height: 100 }
              })
            ]),
            _: 1
          }, 8, ["formData"])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}